module.exports = __webpack_public_path__ + "img/hey.2b1df92.svg";